import { apiClient, fastApiClient } from "../App";

// Executive Summary
export const getExecutiveSummary = () => {
  return fastApiClient.get("/dashboard/executive-summary");
};

// Campaign List (CSV Download)
export const getCampaigns = () => {
  return fastApiClient.get("/campaigns");
};